<template>
  <div>
    <form
      @submit.prevent
      @keyup.enter="onInputEnter"
    >
      <ui-input-group>
        <ui-input
          v-model="nameModel"
          placeholder="* Name"
          autocomplete="nope"
        />
      </ui-input-group>

      <ui-input-group>
        <ui-input
          v-model="addressModel"
          placeholder="* Address"
          autocomplete="nope"
        />
      </ui-input-group>

      <ui-input-group class="relative">
        <ui-input
          v-model="countryModel"
          autocomplete="nope"
          placeholder="* Country"
        />
      </ui-input-group>

      <ui-input-group>
        <ui-input
          v-model="vatNumberModel"
          placeholder="VAT Number"
          autocomplete="off"
        />
      </ui-input-group>

      <div
        v-if="!isValidModel"
        class="mb-1 text-xs text-yellow-300"
      >
        Please fill all required(*) fields!
      </div>
    </form>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import UiInput from './ui/UiInput.vue';
import UiInputGroup from './ui/UiInputGroup.vue';

export default defineComponent({
  name: 'BillingInfoForm',
  components: { UiInput, UiInputGroup },

  props: {
    name: {
      default: '',
      type: String,
    },
    address: {
      default: '',
      type: String,
    },
    country: {
      default: '',
      type: String,
    },
    vatNumber: {
      default: '',
      type: String,
    },
    isValid: {
      default: true,
      type: Boolean,
    }
  },
  emits: ['update:name', 'update:address', 'update:country', 'update:vatNumber', 'update:isValid', 'inputEnter'],

  data(){
    return {
      countryFilter: '',
      countryFieldFocus: false,
    }
  },

  computed: {
    nameModel: {
      get() {
        return this.name;
      },

      set(value) {
        this.$emit('update:name', value);
      }
    },
    addressModel: {
      get() {
        return this.address;
      },

      set(value) {
        this.$emit('update:address', value);
      }
    },
    countryModel: {
      get() {
        return this.country;
      },

      set(value) {
        this.$emit('update:country', value);
      }
    },
    vatNumberModel: {
      get() {
        return this.vatNumber;
      },

      set(value) {
        this.$emit('update:vatNumber', value);
      }
    },

    isValidModel() {
      const valid = !!this.addressModel && !!this.nameModel && !!this.countryModel;
      this.$emit('update:isValid', !!this.addressModel && !!this.nameModel && !!this.countryModel);
      return valid;
    },
  },

  methods: {
    onInputEnter() {
      if (!this.isValidModel) return;
      this.$emit('inputEnter', true);
    },
  },
});
</script>

<style>

</style>